import ReactDOM from "react-dom";
import { SampleOrderButton } from "./SampleOrderButton";
import { DownloadImage } from "./DownloadImage";  

if (document.getElementById('order-sku-button')) {
  const element = document.getElementById('order-sku-button');

  const itemnum = element.getAttribute("data-itemnum");
  const itemname = element.getAttribute("data-itemname");
  const itemcolor = element.getAttribute("data-itemcolor");
  ReactDOM.render(
    <SampleOrderButton 
      itemnum={itemnum} 
      itemname={itemname} 
      itemcolor={itemcolor} 
    />,
    document.getElementById('order-sku-button')
  );
}

if (document.getElementById('productcontainer') ||
	document.getElementById('itemcontainer')) {

	// PLP preview
	const plp_element = document.getElementById('download-image');
	if (plp_element) {
		ReactDOM.render(<DownloadImage />, plp_element);
	}

	// PDP main img
	const pdp_element = document.getElementById('download-image-2');
	if (pdp_element) {
		ReactDOM.render(<DownloadImage icon='/images/icons/download_icon.svg' />, pdp_element);
	}

	// PDP gallery
	Array.prototype.forEach.call(
		document.getElementsByClassName('download-image-gallery'),
		function (el) {
			ReactDOM.render(<DownloadImage />, el)
		}
	)
}